import React, { useState } from "react";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import { Card, Button } from "react-bootstrap";

function Credit() {

    const [showStats, setShowStats] = useState(false);
    const [applyLoan, setapplyLoan] = useState(true);



    const handleShowStats = () => {
        setShowStats(true);
        setapplyLoan(false);
    };

    const stats = [
        {
            title: "Customer Retention Score",
            value: "0.0",
            description: "How often customers come back over time.",
        },
        {
            title: "Points Redemption Score",
            value: "0.0",
            description: "How frequently customers redeem their points.",
        },
        {
            title: "Sales Stability Score",
            value: "0.0",
            description: "Consistency of transactions across days and weeks.",
        },
        {
            title: "Loyalty Growth Score",
            value: "0.0",
            description: "Growth in repeat customers over time.",
        },
        {
            title: "Peak Utilization Score",
            value: "0.0",
            description: "How well your business performs during peak hours.",
        },
        {
            title: "Point Utilization Ratio",
            value: "0.0",
            description: "Percentage of issued points that are actually redeemed.",
        },
        {
            title: "Daily Customer Volume",
            value: "0",
            description: "Average number of customers served per day.",
        },
        {
            title: "Weekly Activity Score",
            value: "0.0",
            description: "How active your shop is throughout the week.",
        },
    ];

    return (
        <div className="dashBCont d-flex">
            <LeftBar />

            <div className="dashBcontA flex-grow-1">
                <NavBarAccount />

                <div className="container py-3">

                    <h3 className="mb-4">Kuza Credit</h3>

                    {applyLoan && (
                    <Card className="mb-4">
                        <Card.Body>
                            <p className="small text-muted">A smart, fast, and flexible way for Kuza Businesses to access loans and grow. Whether you need to restock, boost working capital, or manage daily cash flow, Kuza Credit is here for you.</p>
                            <Card.Title className="myPrimaryColor">Smart Eligibilit</Card.Title>
                            <ul className=" mt-3 small text-muted">
                                <li>Daily customer visits</li>
                                <li>Spread throughout the week</li>
                                <li>Frequent point redemptions</li>
                                <li>Loyal repeat customers</li>
                                <li>Positive growth trend</li>
                            </ul>
                            <p className="small text-muted mt-2">
                                Your score grows as your customers grow. The more active your business, the more credit you can access.
                            </p>
                            <Card.Title className="myPrimaryColor">Smart Eligibilit</Card.Title>
                            <ul className="mt-3 small text-muted">
                                <li>Loan limits range from KES 10,000 to 150,000 depending on your Kuza activity.</li>
                                <li>Repayment terms are between 7 to 30 days, with daily, weekly, or one-time options.</li>
                                <li>No collateral or paperwork required, the process is fully digital.</li>
                                <li>Loans are instantly disbursed to your phone via M-Pesa</li>
                            </ul>



                            <Button className="myPrimaryBtn" onClick={handleShowStats} >Get Started</Button>
                        </Card.Body>
                    </Card>)}




                    {showStats && (
                        <Card className="mb-4">
                            <Card.Body>
                                <Card.Title className="myPrimaryColor mb-4">Your Stats</Card.Title>
                                <div className="row mt-4">

                                    {stats.map((stat, index) => (
                                        <div key={index} className="col-md-4 mb-4">
                                            <div className="card h-100 shadow-sm border-0">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle mb-1 text-muted">{stat.title}</h6>
                                                    <h3 className="card-title text-primary fw-bold">{stat.value}</h3>
                                                    <p className="card-text small">{stat.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <Button className="myPrimaryBtn" onClick={handleShowStats} >Continue</Button>
                            </Card.Body>
                        </Card>
                    )}






                </div>
            </div>
        </div>
    );
}

export default Credit;